<template>
    <div>
        <h1>Check Components Emails</h1>
        <CompassButton label="Test Button" @click="createEmailPanel" />
    </div>
</template>

<script>
export default {
    name: 'CheckEmails',
    data() {
        return {};
    },
    methods: {
        createEmailPanel() {
            this.$trigger('emailPanel:new');
        },
    },
};
</script>
